import {Component, EventEmitter, inject, Output} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-huduma-tgsd',
  templateUrl: './huduma-tgsd.component.html',
  styleUrl: './huduma-tgsd.component.scss'
})
export class HudumaTgsdComponent {
  hudumaList = [
    {name: 'Makundi maalaum', tag: 'Special_Needs', icon: 'disabled'},
    {name: 'Wageni/Foreigners', tag: 'G2F', icon: 'foreigner'},
    {name: 'Biashara', tag: 'G2B', icon: 'biashara'},
    {name: 'Sekta Zote', tag: 'sector', icon: 'sekta'},
    {name: 'Taasisi Zote', tag: 'institution', icon: 'taasisi'},
  ];

  route = inject(Router);


  @Output() exitHover = new EventEmitter();

  routeNext(key: string) {
    this.exitHover.emit(null);
    this.route.navigateByUrl(`/service-by-group/${key}`);
  }

}
